'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import Tooltip from '@/app/_components/Tooltip';
import ProductFavoriteMarker from '@/app/_components/ProductFavoriteMarker';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
const HomeProductListing = t0 => {
  const $ = _c(25);
  const {
    product
  } = t0;
  if (!(product.product_photo || product.thumb_1)) {
    return null;
  }
  let imageSrc;
  if (product.file_name) {
    imageSrc = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.file_name}`;
  } else {
    if (product.thumb_1) {
      imageSrc = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${product.thumb_1}`;
    } else {
      imageSrc = `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${product.product_photo}`;
    }
  }
  if (!product.url) {
    return null;
  }
  const t1 = product.url;
  const t2 = product.sub_product_id;
  let t3;
  if ($[0] !== product.sub_product_name) {
    t3 = decodeEntities(product.sub_product_name);
    $[0] = product.sub_product_name;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== product.sub_product_id || $[3] !== t3) {
    t4 = <ProductFavoriteMarker sub_product_id={t2} productName={t3} />;
    $[2] = product.sub_product_id;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== product.is_best_seller || $[6] !== product.sub_product_name) {
    t5 = product.is_best_seller === 1 && <Tooltip content={`The ${capitalize(decodeEntities(product.sub_product_name))} is a best seller.`}><span className="visible [@media(hover:hover)]:lg:invisible [@media(hover:hover)]:lg:group-hover:visible cursor-default text-light hover:text-primary transition-colors"><FontAwesomeIcon icon={faAward} className="text-xl" /></span></Tooltip>;
    $[5] = product.is_best_seller;
    $[6] = product.sub_product_name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="absolute z-40 bottom-3 left-3 flex items-center gap-4">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== product.designer_name || $[12] !== product.product_name || $[13] !== product.sub_product_name || $[14] !== product.supplier_name) {
    t7 = decodeEntities(product.sub_product_name) || product.product_name || `${product.supplier_name || ""} ${product.designer_name || ""} product`.trim() || "Product image";
    $[11] = product.designer_name;
    $[12] = product.product_name;
    $[13] = product.sub_product_name;
    $[14] = product.supplier_name;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== imageSrc || $[17] !== t7) {
    t8 = <div className="overlay-block bg-white flex-1 flex items-center justify-center"><Image className="object-contain scale-75 sm:scale-85 lg:scale-100 lg:transition-all lg:duration-400 lg:group-hover:scale-105" src={imageSrc} alt={t7} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={160} height={160} quality={90} sizes="160px" /></div>;
    $[16] = imageSrc;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <div className="aspect-square bg-gray-3 p-3 flex flex-col relative">{t6}{t8}</div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== product.url || $[23] !== t9) {
    t10 = <Link href={t1} scroll={true} className="product-listing relative group w-full">{t9}</Link>;
    $[22] = product.url;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default HomeProductListing;